/* =========================================================================
 * Shop the Look — button injection
 *
 * Brilliant Cuts posts mark an image column in the article body with
 * data-stl="<metaobject handle>". sections/main-article.liquid renders a
 * <template data-stl-button="<handle>"> plus a drawer for every look that is
 * both assigned to the article (custom.shop_the_look_looks) and marked in the
 * body. This script clones each template's button into its marked column.
 * Open/close, focus trap and Escape all come from Focal's toggle-button and
 * drawer-content; nothing here handles the drawer itself.
 *
 * A marked column with no matching template is left alone, so a typo'd or
 * unassigned handle renders as a plain image. The lifestyle section
 * (sections/shop-the-look-lifestyle.liquid) renders its button inline and
 * does not use this file.
 * ========================================================================= */
(function () {
  'use strict';

  function templateFor(handle) {
    var value = window.CSS && CSS.escape ? CSS.escape(handle) : handle.replace(/"/g, '\\"');
    return document.querySelector('template[data-stl-button="' + value + '"]');
  }

  function injectButtons(root) {
    var columns = root.querySelectorAll('[data-stl]');

    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      var handle = column.getAttribute('data-stl');

      if (!handle || column.querySelector('.shop-the-look__trigger')) continue;

      var template = templateFor(handle);
      if (!template) continue;

      column.appendChild(template.content.cloneNode(true));
    }
  }

  function init() {
    injectButtons(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders main-article in place; re-inject into the new markup.
  document.addEventListener('shopify:section:load', function (event) {
    injectButtons(event.target.querySelectorAll ? event.target : document);
  });
})();
